import { IconButtonRoot } from "./IconButton.styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC } from "react";
import { IIconButton } from "./IconButton.props";
import { ButtonProps } from "@mui/material";

const IconButton: FC<IIconButton & ButtonProps> = ({ onClick, icon, iconColor, title, buttonSize = "small", iconSize = "xl", ...props }) => {
	return (
		<IconButtonRoot className="icon-button" size={buttonSize} onClick={onClick} {...props}>
			<FontAwesomeIcon icon={icon} color={iconColor} size={iconSize} title={title} />
		</IconButtonRoot>
	);
};

export default IconButton;
